export default {
      id: "phone-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#phone",
      toString: function () {
        return this.url;
      }
    }